(function () {
  'use strict';

  var PROP_NAME = '_quiz_session_id';

  // ── Read session ID from localStorage ────────────────────────────────────
  function getSessionId() {
    try {
      return localStorage.getItem('qf_session_id')
          || localStorage.getItem('qf_completed_session_id')
          || null;
    } catch (e) {
      return null;
    }
  }

  // ── Inject hidden inputs into all product forms ───────────────────────────
  // Adds <input type="hidden" name="properties[_quiz_session_id]" value="...">
  // Skips forms that already have the input.
  function injectIntoForms() {
    var sessionId = getSessionId();
    if (!sessionId) return;

    var forms = document.querySelectorAll('form[action="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      var existing = form.querySelector('input[name="properties[' + PROP_NAME + ']"]');
      if (existing) {
        existing.value = sessionId; // update in case it changed
        continue;
      }
      var input = document.createElement('input');
      input.type  = 'hidden';
      input.name  = 'properties[' + PROP_NAME + ']';
      input.value = sessionId;
      form.appendChild(input);
    }
  }

  // ── Patch fetch to inject property into AJAX /cart/add calls ─────────────
  function patchFetch() {
    var _originalFetch = window.fetch;

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';

      if (url.indexOf('/cart/add') === -1) {
        return _originalFetch.call(window, input, init);
      }

      var sessionId = getSessionId();
      if (!sessionId) {
        return _originalFetch.call(window, input, init);
      }

      // Clone and inject into the request body
      try {
        init = init || {};
        var body = init.body;

        // JSON body
        if (typeof body === 'string') {
          var parsed = JSON.parse(body);
          parsed = injectIntoPayload(parsed, sessionId);
          init = Object.assign({}, init, { body: JSON.stringify(parsed) });

        // FormData body
        } else if (body instanceof FormData) {
          var key = 'properties[' + PROP_NAME + ']';
          if (!body.get(key)) {
            body.append(key, sessionId);
          }
        }
      } catch (e) {
        // Parse failed — send as-is
      }

      return _originalFetch.call(window, input, init);
    };
  }

  // ── Patch XMLHttpRequest for themes that use XHR ─────────────────────────
  function patchXHR() {
    var _originalOpen = XMLHttpRequest.prototype.open;
    var _originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._qfUrl = url || '';
      return _originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      if (this._qfUrl && this._qfUrl.indexOf('/cart/add') !== -1) {
        var sessionId = getSessionId();
        if (sessionId && typeof body === 'string') {
          try {
            var parsed = JSON.parse(body);
            parsed = injectIntoPayload(parsed, sessionId);
            body = JSON.stringify(parsed);
          } catch (e) {}
        }
      }
      return _originalSend.call(this, body);
    };
  }

  // ── Inject _quiz_session_id into a /cart/add payload object ──────────────
  // Handles both single item { id, quantity } and bulk { items: [...] }
  function injectIntoPayload(payload, sessionId) {
    if (!payload) return payload;

    function addProp(item) {
      if (!item) return item;
      item.properties = item.properties || {};
      if (!item.properties[PROP_NAME]) {
        item.properties[PROP_NAME] = sessionId;
      }
      return item;
    }

    if (Array.isArray(payload.items)) {
      payload.items = payload.items.map(addProp);
    } else {
      payload = addProp(payload);
    }

    return payload;
  }

  // ── Observe DOM for dynamically injected product forms (quick-add, etc.) ─
  function observeForms() {
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function () {
      injectIntoForms();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ── Bootstrap ─────────────────────────────────────────────────────────────
  function init() {
    injectIntoForms();
    patchFetch();
    patchXHR();
    observeForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
